var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKava(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 2000 2210",
    viewBox: "0 0 2000 2210",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m198.5 1841.3 123.1 368.7 845-1105-845-1105-129.1 360.7 561.3 744.1z",
    fill: "#ff564f",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1999.7 2209.8h-401l-845.2-1105 845.2-1104.8h401l-833.3 1104.8z",
    fill: "#f08179"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff564f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h321.4v2209.8h-321.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2000 2209.8h-401l-845.2-1105 845.2-1104.8h401l-833.3 1104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2000 2209.8h-401l-845.2-1105 845.2-1104.8h401l-833.3 1104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2000 2209.8h-401l-845.2-1105 845.2-1104.8h401l-833.3 1104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2000 2209.8h-401l-845.2-1105 845.2-1104.8h401l-833.3 1104.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKava);
export default __webpack_public_path__ + "static/media/kava.9e87b5b96aadcdbfd1d865b436298d7c.svg";
export { ForwardRef as ReactComponent };